import styled from 'styled-components';

export const RoutePlaceHolderWrapper = styled.div`
  position: relative;
  height: 680px;
  width: 100%;
`;
